import { motion } from "framer-motion";
import { AboutUsCardStyles } from "./AboutUsCardStyles";
import { ForwardedRef, forwardRef } from "react";
import { AboutUsCardInterface } from "../../../interfaces/AboutUsCardInterface";

export const AboutUsCard = forwardRef(
  (
    { title, text, img, background, width }: AboutUsCardInterface,
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    return (
      <AboutUsCardStyles
        ref={ref}
        style={{
          backgroundImage: `url(${img})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          width: `${width}`,
        }}
      >
        <div>
          <h4>{title}</h4>
          <p>{text}</p>
        </div>
        <span
          style={{
            background: `${background}`,
          }}
        ></span>
      </AboutUsCardStyles>
    );
  }
);

export const MAboutUsCard = motion.create(AboutUsCard);
